// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReserveSettingsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * The reserve admission assumptions — GET/POST /ai/credits/reserve-settings.
 *
 * reserve_floor_micro is the resulting hold for one worst-case turn at the
 * GLOBAL peg, returned so the console can show the consequence of the numbers
 * rather than the numbers alone. A franchise with its own peg holds a
 * proportionally different amount; that is the point of the peg, and the
 * per-franchise floor is visible on the peg table.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_ReserveSettingsResponseDados {
output_tokens: number
input_miss_tokens: number
reserve_floor_micro: number
}

export type AiCredits_ReserveSettingsResponse = ApiResponse<AiCredits_ReserveSettingsResponseDados>;

registerResponseContract('AiCredits_ReserveSettingsResponse', {
  output_tokens:       { type: 'number',  required: true },
  input_miss_tokens:   { type: 'number',  required: true },
  reserve_floor_micro: { type: 'number',  required: true },
})
